export const moduleId = 'petDetails';
export const moduleIdPetTNC = 'petPolicyTnC';
export const moduleIdTNC = 'tnc';
export const sourceProcess = 'OnlineCheckIn';